// client/src/components/HomeCommercant.js

import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import HomeFooter from "./HomeFooter";
import HomeHeader from "./HomeHeader";
import { HomeStyles, StepLine, FeatureCard } from "./HomeUI";

export default function HomeCommercant() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const banner =
    "https://firebasestorage.googleapis.com/v0/b/ecobill-pay.firebasestorage.app/o/Administratif%2Fbanniere_home_commercants.png?alt=media&token=4c4e0836-1537-4f1c-8f1a-cc936f8c3758";

  
  const features = useMemo(
    () => [
      {
        emoji: "❤️",
        title: "Fidélité client",
        reverse: false,
        content: (
          <ul className="lp-checks">
            <StepLine>Personnalisez votre programme de fidélité</StepLine>
            <StepLine>Comptabilisez chaque visite de vos clients</StepLine>
            <StepLine>Choisissez le nombre de passages requis</StepLine>
            <StepLine>Sélectionnez le gain à débloquer</StepLine>
          </ul>
        ),
      },
      {
        emoji: "⭐️",
        title: "Taux de satisfaction client",
        reverse: true,
        content: (
          <>
            <p className="lp-text" style={{ marginBottom: 14 }}>
              Après le scan du QR-Code, vos clients vous notent de 1 à 5 étoiles.
            </p>
            <ul className="lp-checks">
              <StepLine>Collectez un taux réel (simple & rapide)</StepLine>
              <StepLine>Suivez l’évolution dans votre dashboard</StepLine>
              <StepLine>Analysez les retours en temps réel</StepLine>
            </ul>
          </>
        ),
      },
      {
        emoji: "📣",
        title: "Annonces & promotions",
        reverse: false,
        content: (
          <ul className="lp-checks">
            <StepLine>Publiez vos annonces et promotions</StepLine>
            <StepLine>Communiquez auprès de tous nos utilisateurs</StepLine>
          </ul>
        ),
      },
      {
        emoji: "🧾",
        title: "Factures centralisées",
        reverse: true,
        content: (
          <ul className="lp-checks">
            <StepLine>Regroupez vos factures d’achats professionnels</StepLine>
            <StepLine>Donnez des accès restreints à vos salariés</StepLine>
            <StepLine>Gardez tout au même endroit</StepLine>
          </ul>
        ),
      },
    ],
    []
  );

  return (
    <div className={`lp-page${isMobile ? " is-mobile" : ""}`}>
      <HomeStyles />
      <HomeHeader />

      <header className="lp-hero">
        <div className="lp-shell">
          <div className="lp-hero__grid">
            <div>
              <span className="lp-eyebrow">
                <span className="lp-eyebrow__dot" aria-hidden="true" />
                Ecobill — côté entreprises
              </span>

              <h1 className="lp-h1">Fidélisez, mesurez, communiquez</h1>

              <p className="lp-lead">
                Un package complet pour booster votre rétention client et centraliser l’administratif.
              </p>

              <div className="lp-actions">
                <Link to="/merchantsignup" className="lp-btn lp-btn--primary">
                  Créer mon compte <span className="lp-btn__arrow" aria-hidden="true">→</span>
                </Link>
                <Link to="/merchantofferselection" className="lp-btn lp-btn--secondary">
                  Nos tarifs <span className="lp-btn__arrow" aria-hidden="true">→</span>
                </Link>
              </div>
            </div>

            <div className="lp-media">
              <img src={banner} alt="Bannière commerçants" />
            </div>
          </div>

        </div>
      </header>

      <main className="lp-main">
        <div className="lp-shell">
          <section className="lp-section">
            <div className="lp-grid">
              {features.map((f, i) => (
                <FeatureCard key={i} emoji={f.emoji} title={f.title}>
                  {f.content}
                </FeatureCard>
              ))}
            </div>
          </section>
        </div>
      </main>

      <HomeFooter />
    </div>
  );
}
